/**
 * W3 — Requisições internas (RQA/RQI) autorizadas e ainda não separadas além
 * do limite de dias úteis das Configurações. Mesmo número do sino.
 */
import React from "react";
import { Link } from "react-router-dom";

import { CardBody, CardFooter, KpiSub, KpiValor, LinkLight } from "../styles";
import { pendenciasSolicitacoes, temAcaoEmAlgumTipo } from "./_solicitacoesInternas";

export const meta = {
  id: "requisicoes_separar",
  label: "Requisições internas a separar",
  descricao: "Requisições de almoxarifado e insumo autorizadas que passaram do prazo de separação.",
  categoria: "Pendencias",
  permissoes: [],
  visivelPara: (hasAllPermissions, isMaster) =>
    isMaster || temAcaoEmAlgumTipo(hasAllPermissions, "atender", ["rqa", "rqi"]),
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const r = await pendenciasSolicitacoes(request);
  return { atrasadas: r?.sem_separacao ?? 0, presas: r?.reservas_presas ?? 0 };
}

export function Widget({ dados }) {
  const n = dados?.atrasadas ?? 0;
  const presas = dados?.presas ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: n > 0 ? "var(--danger-text)" : undefined }}>{n}</KpiValor>
        <KpiSub>
          {n > 0 ? "além do prazo de separação" : "Nenhuma atrasada"}
          {presas > 0 ? ` · ${presas} com reserva presa` : ""}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/minhas-pendencias">Ver pendências</LinkLight>
      </CardFooter>
    </>
  );
}
